// import React, { useState, useEffect} from 'react';
// import '../../App.css';
// import HeroSection from '../HeroSection';
// import Footer from '../Footer';
// import Button from '@mui/material/Button';
// import { Link } from 'react-router-dom';
// import { useAuth } from '../../AuthContext';
// import { tokenIsExpired } from '../../authUtils';

// function Home() {
//   const { isAuthenticated, companyId, permissions, roleName } = useAuth();

//   return (
//     <>
//       <HeroSection />

//     </>
//   );
// }

// export default Home;

import React, { Fragment, useState, useEffect } from 'react';
import '../../App.css';
import HeroSection from '../HeroSection';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Footer from '../Footer';
import { useAuth } from '../../AuthContext';
import { tokenIsExpired } from '../../authUtils';
import { fetchData, deleteData, activateData, fetchhistory, updateData, postData, fetchEngineerStockDetails } from '../../apiService';
import CircularProgress from '@mui/material/CircularProgress';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import { Link } from 'react-router-dom';
import { Tooltip } from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import CallIcon from '@mui/icons-material/Call';
import Select from 'react-select';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import DoneIcon from '@mui/icons-material/Done';
import CancelIcon from '@mui/icons-material/Cancel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'; // or another appropriate package

function Home() {
  const { isAuthenticated, roleName, userId, companyId, token, logout } = useAuth();
  const [serviceListCount, setServiceListCount] = useState(0);
  const [serviceListData, setServiceListData] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   if (isAuthenticated && tokenIsExpired(token)) {
  //     logout();
  //   }
  // }, [isAuthenticated, token, logout]);

  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) {
      logout();
      return;
    }

    const fetchtableData = async () => {
      // Add your logic to fetch table data here
      await handleExperingWarrantyClick(companyId, userId);
    };

    fetchtableData();
  }, [isAuthenticated, companyId, userId, token, logout]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetchEngineerStockDetails('ScheduleServiceApi', companyId, userId, token);
        if (response.responseCode === '1111') {
          setServiceListData(response.response_data);
          setServiceListCount(response.response_data.length);
          //console.log(response);
        } else {
          console.error('Error fetching data:', response.errorMessage);
        }
      } catch (error) {
        console.error('Error occurred while fetching data:', error);
      }
      finally {
        setLoading(false); // Hide loading screen
      };
    }

    if (roleName === 'Engineer') {
      fetchData();
    }
  }, [companyId, userId, token, roleName]);

  // for Company Manager - role COmpany Admin

  useEffect(() => {
    fetchtableData();
  }, []);

  // const fetchtableData = async () => {

  //   fetchData('RequestdetailsApi', `/${companyId}`, token)
  //     .then((response) => {
  //       if (response.responseCode == '1111') {
  //         // console.log(response);
  //         setData(response.response_data);

  //       }
  //     })
  //     .catch((error) => {
  //       console.error('Error fetching Request Details:', error);
  //     });

  // };

  const fetchtableData = async () => {
    setLoading(true);
    try {
      const response = await fetchData('RequestdetailsApi', `/${companyId}`, token);
      if (response.responseCode == '1111') {
        console.log(response);
        setData(response.response_data);
      }
    } catch (error) {
      console.error('Error fetching Request Details:', error);
    } finally {
      setLoading(false); // Hide loading screen
    }
  };

  // FOR receptionist

  const [Remark, setRemark] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  //  const [selectedCustomer, setSelectedCustomer] = useState({});

  const [customerTypeOptions, setCustomerTypeOptions] = useState([]);
  const [selectedCustomerType, setSelectedCustomerType] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) {
      logout();
    }
  }, [isAuthenticated, token, logout, companyId]);
  const [isLoading, setIsLoading] = useState(false);

  //Work Type
  const [workTypeOptions, setWorkTypeOptions] = useState([]);
  const [selectedWorkType, setSelectedWorkType] = useState("");

  const fetchWorkTypes = async () => {
    try {
      const response = await fetchData('WorkStatusApi', `/${companyId}`);
      if (response.responseCode === '1111') {
        setWorkTypeOptions(response.response_data);
      }
    } catch (error) {
      console.error('Error fetching Work Types:', error);
    }
  };


  useEffect(() => {
    fetchCustomerTypes();
    fetchWarrantyTypes();
    fetchWorkTypes();
    fetchRequestTypes();
    fetchProductTypes();
  }, []);


  // const [customerName, setCustomerName] = useState('');
  const [contactNumber1, setContactNumber1] = useState('');
  const [contactNumber2, setContactNumber2] = useState('');
  const [addressline1, setAddressLine1] = useState("");
  const [town, setTown] = useState("");
  const [pincode, setPostcode] = useState("");
  const [district, setDistrict] = useState("");
  const [state, setState] = useState("");
  const [customertype, setCustomertype] = useState('');
  const [contactperson, setContactperson] = useState('');
  const [email, setEmail] = useState("");

  const [landmark, setLandmark] = useState('');

  useEffect(() => {
    fetchData('CustomerApi', `/${companyId}`)
      .then((response) => {
        if (response.responseCode == '1111') {
          setCustomerName(response.response_data);
        }
      })
      .catch((error) => {
        console.error('Error fetching Customer:', error);
      });
  }, []);



  //Customer create Modal
  const [modal, setModal] = useState("");

  const [names, setNames] = useState("");
  const [emails, setEmails] = useState("");
  const [gstNumbers, setGstNumbers] = useState("");
  const [contactNumber1s, setContactNumber1s] = useState("");
  const [contactNumber2s, setContactNumber2s] = useState("");
  const [addressline1s, setAddressLine1s] = useState("");
  const [addressline2s, setAddressLine2s] = useState("");
  const [landMarks, setLandMarks] = useState("");
  const [towns, setTowns] = useState("");
  const [pincodes, setPostcodes] = useState("");
  const [contactPersons, setcontactPersons] = useState("");
  const [districts, setDistricts] = useState("");
  const [states, setStates] = useState("");
  const [countrys, setCountrys] = useState("");
  const [customerTypeIDs, setCustomerTypeIDs] = useState("");
  const [customerTypeOptionss, setcustomerTypeOptionss] = useState([]);
  const [selectedCustomerTypes, setSelectedCustomerTypes] = useState("");
  const [pinCodess, setPinCodess] = useState([]);
  const [successMessages, setSuccessMessages] = useState("");
  const [errorMessages, setErrorMessages] = useState("");

  useEffect(() => {
    fetchData('PinCodeApi', `/${companyId}`, token)
      .then((response) => {
        if (response.responseCode == '1111') {
          setPinCodess(response.response_data);
        }
      })
      .catch((error) => {
        console.error('Error fetching PIN codes:', error);
      });
  }, []);

  const handlePinCodeChange = (event) => {
    const value = event;
    if (value.length === 6) {
      const selectedPinCode = pinCodess.find(pincodes => pincodes.Postcode === value);
      if (selectedPinCode) {
        //setCity(selectedPinCode.City);
        setDistricts(selectedPinCode.District);
        setPostcodes(selectedPinCode.Postcode);
        setCountrys(selectedPinCode.Country);
        setStates(selectedPinCode.State);
      }
    }
  };

  const submitCustomData = async (e) => {
    e.preventDefault();
    if (!names || !contactNumber1s) {
      setErrorMessages("All fields are required!");
      return;
    }

    try {
      const selectedCustomerTypeId = customerTypeOptions.find(option => option.type === selectedCustomerType)?.id;

      const CustomerCreateData = {
        CustomerName: names,
        CompanyID: companyId,
        //CustomerTypeID: selectedCustomerTypeId,
        Customertype: selectedCustomerType.label,
        ContactNumber1: contactNumber1s,
        ContactNumber2: contactNumber2s,
        Email: emails,
        GSTNumber: gstNumbers,
        AddressLine1: addressline1s,
        AdressLine2: addressline2s,
        LandMark: landMarks,
        PinCode: pincodes,
        Town: towns,
        District: districts,
        State: states,
        Country: countrys,
        GPSLocation: null,
        ContactPerson: contactPersons,
        CreatedBy: userId,
        CreatedDate: new Date(),
      };

      postData('CustomerApi', CustomerCreateData, token)
        .then((response) => {
          console.log('Customer Created success:', response);
          setNames("");
          setContactNumber1s("");
          setContactNumber2s("");
          setAddressLine1s("");
          setAddressLine2s("");
          setPostcodes("");
          setEmails("");
          setGstNumbers("");
          setPinCodess("");
          setLandMarks("");
          setTowns("");
          setcontactPersons("");
          setDistricts("");
          setStates("");
          setCountrys("");
          setSelectedCustomerType("");
          setSuccessMessages("customer Created successful!");
          setErrorMessages(""); // Clear error message on success
          // Reload the page after successful submission
          window.location.reload();
        })
        .catch((error) => {
          console.error('Item Create error:', error);
        });
    } catch (error) {
      console.error('Item Create error:', error);
    }
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  //Request Type
  const [requestTypeOptions, setRequestTypeOptions] = useState([]);
  const [selectedRequestType, setSelectedRequestType] = useState("");

  const fetchRequestTypes = async () => {
    try {
      const response = await fetchData('BrandApi', `/${companyId}`);
      if (response.responseCode === '1111') {

        const options = response.response_data.map(type => ({
          value: type.name,
          label: type.name
        }));
        setRequestTypeOptions(options);
      }
    } catch (error) {
      console.error('Error fetching Request Types:', error);
    }
  };

  const handleRequestTypeChange = (selectedOption) => {
    setSelectedRequestType(selectedOption);
  };


  //Product Type
  const [productTypeOptions, setProductTypeOptions] = useState([]);
  const [selectedProductType, setSelectedProductType] = useState("");

  const fetchProductTypes = async () => {
    try {
      const response = await fetchData('CategoryApi', `/${companyId}`);
      if (response.responseCode === '1111') {

        const options = response.response_data.map(product => ({
          value: product.name,
          label: product.name
        }));
        setProductTypeOptions(options);
      }
    } catch (error) {
      console.error('Error fetching Category Types:', error);
    }
  };

  const handleProductChange = (selectedOption) => {
    setSelectedProductType(selectedOption);
  };

  //Warrenty Type
  const [warrantyTypeOptions, setWarrantyTypeOptions] = useState([]);
  const [selectedWarrantyType, setSelectedWarrantyType] = useState("");

  const fetchWarrantyTypes = async () => {
    try {
      const response = await fetchData('WarrentyStatusApi', `/${companyId}`);
      if (response.responseCode === '1111') {

        const options = response.response_data.map(warranty => ({
          value: warranty.type,
          label: warranty.type
        }));
        setWarrantyTypeOptions(options);
      }
    } catch (error) {
      console.error('Error fetching Warrenty Types:', error);
    }
  };

  const handleWarrantyChange = (selectedOption) => {
    setSelectedWarrantyType(selectedOption);
  };

  //customer
  const [customerName, setCustomerName] = useState([]);
  const [customerOptions, setCustomerOptions] = useState([]);

  useEffect(() => {
    fetchData('CustomerApi', `/${companyId}`)
      .then((response) => {
        if (response.responseCode === '1111') {
          const options = response.response_data.map(customer => ({
            value: customer.customerName,
            label: customer.customerName
          }));
          setCustomerOptions(options);
        }
      })
      .catch((error) => {
        console.error('Error fetching Customer:', error);
      });
  }, []);

  //customer type
  const fetchCustomerTypes = async () => {
    try {
      const response = await fetchData('CustomerTypeApi', `/${companyId}`);
      if (response.responseCode === '1111') {

        const options = response.response_data.map(customer => ({
          value: customer.type,
          label: customer.type
        }));
        setCustomerTypeOptions(options);
      }
    } catch (error) {
      console.error('Error fetching Customer Types:', error);
    }
  };
  const handleCustomerTypeChange = (selectedOption) => {
    setSelectedCustomerType(selectedOption);
  };


  const submitData = async (e) => {
    e.preventDefault();
    if (!selectedCustomer || !selectedRequestType || !selectedProductType || !selectedWarrantyType) {
      setErrorMessages("All fields are required!");
      return;
    }

    try {

      const RequestCreateData = {
        Customer: selectedCustomer.label,
        CompanyID: companyId,
        Modal: modal,
        Product: selectedProductType.label,
        ServiceRequestTypes: selectedRequestType.label,
        warranty: selectedWarrantyType.label,
        WorkStatusID: 1,
        StaffAppointmentID: null,
        Remarks: Remark,
        AllocatedBy: null,
        AllocatedDate: null,
        ReAllocatedDate: null,
        CreatedBy: userId,
        CreatedDate: new Date(),
      };

      postData('ServiceRequestApi', RequestCreateData, token)
        .then((response) => {
          console.log('Request Created success:', response);
          setSelectedCustomer(null);
          setCustomertype("");
          setContactNumber1("");
          setAddressLine1("");
          setLandmark("");
          setEmail("");
          setContactperson("");
          setSelectedRequestType("");
          setSelectedProductType("");
          setSelectedWarrantyType("");
          setModal("");
          setRemark("");
          setSuccessMessage("Call Registration successfully!");
          setErrorMessages("");

          setTimeout(() => {
            setSuccessMessage("");
          }, 3000); // 3 seconds
        })
        .catch((error) => {
          console.error('Request Create error:', error);
          setErrorMessages("Failed to create Call. Please try again later.");
        });

    } catch (error) {
      console.error('Request Create error:', error);
      setErrorMessages("An error occurred. Please try again later.");
    }
  };

  const handleCustomerChange = (selectedOption) => {
    setSelectedCustomer(selectedOption);
    if (selectedOption) {
      const selectedCustomerData = customerName.find(customer => customer.customerName === selectedOption.label);
      if (selectedCustomerData) {
        setContactNumber1(selectedCustomerData.contactNumber1);
        setContactNumber2(selectedCustomerData.contactNumber2);
        setEmail(selectedCustomerData.email);
        setCustomertype(selectedCustomerData.customertype);
        setContactperson(selectedCustomerData.contactPerson);
        setAddressLine1(`${selectedCustomerData.town}, ${selectedCustomerData.pinCode}, ${selectedCustomerData.district}, ${selectedCustomerData.state}`);
        setLandmark(selectedCustomerData.landMark);
      }
    } else {
      // Clear the customer data if no customer is selected
      setContactNumber1("");
      setContactNumber2("");
      setEmail("");
      setCustomertype("");
      setContactperson("");
      setAddressLine1("");
      setLandmark("");
    }
  };


  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  function isExpired(dateString) {
    const currentDate = new Date();
    const date = new Date(dateString);
    return date < currentDate;
  }

  const [experingwarrantytData, setExperingWarrantyData] = useState([]);
  const [isexperingWarrantyModalOpen, setIsExperingWarrantyModalOpen] = useState(false);
  const [expiringWarrantyCount, setExpiringWarrantyCount] = useState(0);


  const openexperingdataModal = () => setIsExperingWarrantyModalOpen(true);
  const closeExperingModal = () => setIsExperingWarrantyModalOpen(false);

  const handleExperingWarrantyClick = async (companyId, userId) => {
    try {
      const response = await fetchData('CustomerTypeApi', `/RequestDetails/${companyId}/${userId}`, token);
      if (response.responseCode === '1111') {
        const warrantyData = response.response_data;
        setExperingWarrantyData(warrantyData);
        const count = warrantyData.length;
        setExpiringWarrantyCount(count);

        if (count > 0) {
          console.log(response);
          openexperingdataModal();
        }
      }
    } catch (error) {
      console.error('Error occurred while fetching Warranty data:', error);
    }
  };


  useEffect(() => {
    // Inject keyframes into the document head
    const styleSheet = document.styleSheets[0];
    const keyframes =
      `@keyframes blink {
        0% { opacity: 1; }
        50% { opacity: 0; }
        100% { opacity: 1; }
      }`;
    styleSheet.insertRule(keyframes, styleSheet.cssRules.length);
  }, []);


  return (

    <>

      {roleName === 'Engineer' && (
        <div className="dashboard" style={{ overflowY: 'auto' }}>
          <h6 component="div" style={{ textAlign: 'center', fontWeight: 'bolder', fontFamily: 'Times New Roman', color: 'black' }}>SERVICES</h6>
          {loading && (
            <div style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 9999
            }}>
              <div>
                <CircularProgress style={{ color: 'white' }} />
                <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
              </div>
            </div>
          )}
          {serviceListData.length > 0 ? (
            <div className="card-container">
              {serviceListData
                .filter((service) => service.engineerWorkSS !== 'Completed') // Exclude Completed status
                .map((service, index) => (
                  <div key={index} className={`card ${service.engineerWorkSS === 'OnHold' ? 'bg-green' : service.engineerWorkSS === 'InProgress' ? 'bg-red' : ''}`} style={{ backgroundColor: '#BCEAD5' }}>
                    <div className="status-container">
                      {service.engineerWorkSS !== 'Completed' && (
                        <Tooltip title="Tap To Open the Working Window">
                          <Link to={`/UpdateRequest/${service.requestID}`} className="tooltip-link">
                            <h5 className='psheading linkcolor' style={{ fontFamily: 'Times New Roman', color: 'black' }}>{service.engineerWorkSS}</h5>
                          </Link>
                        </Tooltip>
                      )}
                      {service.engineerWorkSS === 'OnHold' && (
                        <div className="icon">
                          <CircularProgress style={{ marginLeft: '3px', color: 'green', width: '20px', height: '20px', fontWeight: 'bolder' }} />
                        </div>
                      )}
                      {service.engineerWorkSS === 'InProgress' && (
                        <div className="icon">
                          <HourglassEmptyIcon className="hourglass-icon" style={{ marginLeft: '3px', color: 'red', fontWeight: 'bolder' }} />
                        </div>
                      )}
                    </div>
                    <p className="card-info" style={{ color: 'black', fontWeight: 'bolder' }}>
                      Call Date: {service.createdDate && new Date(service.createdDate).toLocaleDateString('en-GB')}
                    </p>
                    <p className="card-info" style={{ color: 'black', fontWeight: 'bolder', fontSize: '12px' }}>Call No: {service.callSerialNo}</p>
                    <p className="card-info" style={{ color: 'black', fontWeight: 'bolder', fontSize: '12px' }}>Customer: {service.customer}</p>
                    <p className="card-info" style={{ color: 'black', fontWeight: 'bolder', fontSize: '12px' }}>Product: {service.product}</p>
                    <p className="card-info" style={{ color: 'black', fontWeight: 'bolder', fontSize: '12px' }}>Model: {service.productModel}</p>
                    <p className="card-info" style={{ color: 'black', fontWeight: 'bolder', fontSize: '12px' }}>M.Seial No: {service.modal}</p>
                  </div>
                ))}
            </div>
          ) : (
            <h5 style={{ fontFamily: 'Times news roman', color: 'black', textAlign: 'center', fontWeight: 'bolder' }}>
              No data found
            </h5>
          )}

        </div>
      )}


      {roleName === 'CompanyAdmin' && (
        <div className="bg-blue-450 rounded-lg shadow-lg p-6">
          <h6 component="div" style={{ textAlign: 'center', fontWeight: 'bolder', fontFamily: 'Times New Roman', color: 'black' }}>WAITING FOR SCHEDULE</h6>
          {loading && (
            <div style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 9999
            }}>
              <div>
                <CircularProgress style={{ color: 'white' }} />
                <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
              </div>
            </div>
          )}
          <div className="card-container" style={{ overflowY: 'auto' }}>
            {data.length > 0 ? (
              data.map((schedule, index) => (
                <div key={index} className={`card ${schedule.workstatus === 'New' ? 'bg-green' : ''}`} style={{ backgroundColor: '#BCEAD5' }}>
                  <div className="status-container">
                    <Tooltip title="Tap to Open the Allocate View">
                      <Link to={`/Allocaterequest/${schedule.requestID}`} className="tooltip-link">
                        <h5 className='psheading linkcolor' style={{ fontFamily: 'Times New Roman', color: 'black' }}>{schedule.workstatus}</h5>
                      </Link>
                    </Tooltip>
                    {schedule.workstatus === 'New' && (
                      <div className="icon zoom-icon">
                        <AssignmentIcon className="Assign-icon" style={{ marginLeft: '10px', color: 'darkred', width: '20px', height: '20px', fontWeight: 'bolder' }} />
                      </div>
                    )}
                  </div>
                  <p className="card-info" style={{ color: 'black', fontWeight: 'bolder', fontSize: '12px' }}>Call No: {schedule.callSerialNo}</p>
                  <p className="card-info" style={{ color: 'black', fontWeight: 'bolder', fontSize: '12px' }}>Customer: {schedule.customer}</p>
                  {/* <p className="card-info" style={{ color: 'black', fontWeight: 'bolder' }}>Address: {schedule.address}</p> */}
                  <p className="card-info" style={{ color: 'black', fontWeight: 'bolder', fontSize: '12px' }}>Product: {schedule.product}</p>
                  <p className="card-info" style={{ color: 'black', fontWeight: 'bolder', fontSize: '12px' }}>Model: {schedule.productModel}</p>
                  <p className="card-info" style={{ color: 'black', fontWeight: 'bolder', fontSize: '12px' }}>Warranty: {schedule.warranty}</p>
                </div>
              ))
            ) : (

              <h5 style={{ fontFamily: 'Times news roman', color: 'black', fontWeight: 'bolder' }}>No Services for Schedule</h5>

            )}
          </div>
        </div>
      )}

      {roleName === 'CompanyAdmin' && (


        < Modal open={isexperingWarrantyModalOpen} onClose={closeExperingModal} className={isexperingWarrantyModalOpen ? 'notification-modal' : ''}>
          <div className="fixed inset-0 flex items-center justify-center z-10">
            <div className=" p-6 rounded-lg shadow-lg" style={{ width: '900px', overflowY: 'auto', backgroundColor: 'brown' }}>
              <div className='w-full mb-2 flex justify-end'>
                <Tooltip title="Close">
                  <button className="close-button" onClick={closeExperingModal} style={{ marginLeft: '8px' }}><CancelIcon style={{ color: 'whitesmoke' }} /></button>
                </Tooltip>
              </div>

              <h6
                style={{
                  fontFamily: 'Times New Roman',
                  textAlign: 'center',
                  color: 'whitesmoke',
                  marginTop: '-40px',
                  fontWeight: 'bolder'

                }}
              >
                WARRANTY EXPIRING DETAILS({expiringWarrantyCount})
                <FontAwesomeIcon
                  icon={faTriangleExclamation}
                  style={{
                    marginLeft: '5px',
                    color: 'yellow',
                    height: '20px',
                    animation: 'blink 1s infinite'
                  }}
                />
              </h6>

              <TableContainer component={Paper} style={{ overflowY: 'auto' }}>
                <Table>
                  <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
                    <TableRow>
                      <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', textTransform: 'uppercase' }}>Sl.No</TableCell>
                      <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', textTransform: 'uppercase' }}>Customer</TableCell>
                      <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', textTransform: 'uppercase' }}>Contact No</TableCell>
                      <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', textTransform: 'uppercase' }}>Expired Date</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {experingwarrantytData.map((item, index) => (
                      <TableRow key={item.Id}>
                        <TableCell sx={{ fontSize: '13px', padding: '2px' }}>{index + 1}</TableCell>
                        <TableCell sx={{ fontSize: '13px', padding: '2px', color: 'darkmagenta', fontWeight: 'bolder' }}>{item.customerName}</TableCell>
                        <TableCell sx={{ fontSize: '13px', padding: '2px' }}>{item.contactNumber1}</TableCell>
                        <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '13px', padding: '2px', color: 'red' }}>
                          {isExpired(item.warrentyExpireDate) ? `Expired on ${formatDate(item.warrentyExpireDate)}` : formatDate(item.warrentyExpireDate)}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        </Modal >

      )
      }

      {roleName === 'Receptionist' && (

        <Fragment>
          <div style={{ backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bolder' }}>
            {successMessage && <p className="text-blue-500">{successMessage}</p>}
          </div>
          <div className="w-full max-w-sm container mt-6 mx-auto">
            <form onSubmit={submitData}>
              <div className="w-full mb-2 flex items-center">
                <h6 className="psheading flex-grow linkcolor" style={{ fontFamily: 'Times New Roman', fontSize: '27px', color: 'black' }}>Call Registration</h6>

                <Tooltip title="Exit">
                  <Button onClick={openModal} style={{ color: 'darkred', fontWeight: 'bolder' }} disabled={isLoading}>
                    <PersonAddIcon /> {isLoading ? <CircularProgress size={24} color="inherit" /> : "New Customer"}
                  </Button>
                </Tooltip>
                |
                <Tooltip title="Submit">

                  <Button onClick={submitData} style={{ color: 'darkgreen', fontWeight: 'bolder' }} disabled={isLoading}>
                    <CallIcon /> {isLoading ? <CircularProgress size={24} color="inherit" /> : "Add Call"}
                  </Button>

                </Tooltip>


              </div>
              <br></br>
              <div className="w-full mb-4 flex">

                <div className="w-1/4 mr-2">
                  <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                    Name
                  </label>
                  <Select
                    value={selectedCustomer}
                    onChange={handleCustomerChange}
                    options={customerOptions}
                    placeholder="Select Name"
                    isSearchable
                  />
                </div>

                <div className="w-1/7 mr-2">
                  <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                    Customer Type
                  </label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    value={customertype}
                    onChange={(e) => setCustomertype(e.target.value)} type="text" placeholder="customerType"
                    disabled
                    style={{ backgroundColor: 'white' }}
                  />
                </div>
                <div className="w-1/4 mr-2">
                  <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="contactNumber1">
                    ContactNo
                  </label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    value={contactNumber1}
                    onChange={(e) => {
                      const input = e.target.value.replace(/\D/g, '');
                      if (input.length <= 15) {
                        setContactNumber1(input);
                      }
                    }}
                    disabled
                    style={{ backgroundColor: 'white' }}
                    type="text"
                    placeholder="Enter Contact Number 1"
                  />
                </div>

                <div className="w-1/2 mr-2">
                  <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="AddressLine1">
                    AddressLine
                  </label>
                  <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    value={addressline1}
                    onChange={(e) => setAddressLine1(e.target.value)}
                    type="text"
                    disabled
                    style={{ backgroundColor: 'white' }}
                    placeholder="Enter Address Line" />
                </div>


              </div>
              <div className="w-full mb-4 flex">
                <div className="w-1/4 mr-2">
                  <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="landmark">
                    Landmark
                  </label>
                  <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    value={landmark}
                    onChange={(e) => setLandmark(e.target.value)}
                    type="text"
                    disabled
                    style={{ backgroundColor: 'white' }}
                    placeholder="Enter Landmark"
                  />
                </div>
                <div className="w-1/4 mr-2">
                  <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="email">
                    Email
                  </label>
                  <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    type="text"
                    disabled
                    style={{ backgroundColor: 'white' }}
                    placeholder="Enter Email" />
                </div>



                <div className="w-1/4 mr-2">
                  <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                    Category
                  </label>

                  <Select
                    value={selectedProductType}
                    onChange={handleProductChange}
                    options={productTypeOptions}
                    placeholder="Select category"
                    isSearchable
                  />
                </div>

                <div className="w-1/4 mr-2">
                  <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                    Brand
                  </label>

                  <Select
                    value={selectedRequestType}
                    onChange={handleRequestTypeChange}
                    options={requestTypeOptions}
                    placeholder="Select Brand"
                    isSearchable
                  />
                </div>
                <div className="w-1/4 mr-2">
                  <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="name">
                    Model
                  </label>
                  <input
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    value={modal}
                    onChange={(e) => setModal(e.target.value)}
                    type="text"
                    placeholder="Enter Modal"
                    maxLength={25}
                  />
                </div>

              </div>
              <div className="w-full mb-4 flex">
                <div className="w-1/4 mr-2">
                  <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                    Warranty
                  </label>

                  <Select
                    value={selectedWarrantyType}
                    onChange={handleWarrantyChange}
                    options={warrantyTypeOptions}
                    placeholder="Warranty-Type"
                    isSearchable
                  />
                </div>
                <div className="w-1/5 mr-1" style={{ width: '325px' }}>
                  <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="packingDate" style={{ fontSize: '16px' }}>
                    Remark <span style={{ color: 'red' }}>*</span>
                  </label>
                  <textarea
                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    value={Remark}
                    onChange={(e) => setRemark(e.target.value)}
                    placeholder="Enter Remarks"
                    rows={3}
                    maxLength={150}

                  />
                </div>


              </div>

            </form>
            <Modal open={isModalOpen} onClose={closeModal} className={isModalOpen ? 'notification-modal' : ''}>
              <div className="fixed inset-0 flex items-center justify-center z-10">
                <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '1300px' }}>
                  <div className="w-full mb-4 flex">

                    <form onSubmit={submitCustomData}>
                      <br></br>
                      <div className='w-full mb-2 flex items-center'>
                        <h6 className='psheading flex-grow linkcolor' style={{ fontWeight: 'bolder', fontSize: '27px', color: 'black', textAlign: 'center' }}>Customer Create</h6>
                      </div>
                      {errorMessages && <p className="text-red-500">{errorMessages}</p>}
                      {successMessages && <p className="text-green-500">{successMessages}</p>}
                      <br></br>
                      <div className="w-full mb-4 flex">
                        <div className="w-1/4 mr-2">
                          <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                            Customer Type
                          </label>

                          <Select
                            value={selectedCustomerType}
                            onChange={handleCustomerTypeChange}
                            options={customerTypeOptions}
                            placeholder="Customer-Type"
                            isSearchable
                          />
                        </div>
                        <div className="w-1/4 mr-2">
                          <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '14px' }}>
                            Name
                          </label>
                          <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={names}
                            onChange={(e) => setNames(e.target.value)}
                            type="text"
                            placeholder="Enter Name"
                          />
                        </div>
                        {selectedCustomerType && (selectedCustomerType.label === 'IGST' || selectedCustomerType.label === 'B to B') && (

                          <div className="w-1/4 mr-2">
                            <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '14px' }}>
                              Contact Person
                            </label>
                            <input
                              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                              value={contactPersons}
                              onChange={(e) => setcontactPersons(e.target.value)}
                              type="text"
                              placeholder="Contact person"
                            />
                          </div>
                        )}
                        <div className="w-1/4 mr-2">
                          <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="contactNumber1">
                            ContactNo:1
                          </label>
                          <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={contactNumber1s}
                            onChange={(e) => {
                              const input = e.target.value.replace(/\D/g, '');
                              if (input.length <= 15) {
                                setContactNumber1s(input);
                              }
                            }}
                            type="text"
                            placeholder="Contact Number 1"
                          />
                        </div>

                        <div className="w-1/4 mr-2">
                          <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="contactNumber2">
                            ContactNo:2
                          </label>
                          <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={contactNumber2s}
                            onChange={(e) => {
                              const input = e.target.value.replace(/\D/g, '');
                              if (input.length <= 15) {
                                setContactNumber2s(input);
                              }
                            }}
                            type="text"
                            placeholder="Contact Number 2"
                          />
                        </div>

                        <div className="w-1/4 mr-2">
                          <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="email">
                            Email
                          </label>
                          <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={emails} onChange={(e) => setEmails(e.target.value)} type="text" placeholder="Email" />
                        </div>


                      </div>

                      <div className="w-full mb-4 flex">
                        {selectedCustomerType && (selectedCustomerType.label === 'IGST' || selectedCustomerType.label === 'B to B') && (

                          <div className="w-1/4 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="gstNumber">
                              GST Number
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                              value={gstNumbers} onChange={(e) => setGstNumbers(e.target.value)} maxLength={15} type="text" placeholder="GST Number" />
                          </div>
                        )}
                        <div className="w-1/2 mr-2">
                          <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="AddressLine1">
                            Address Line 1
                          </label>
                          <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={addressline1s} onChange={(e) => setAddressLine1s(e.target.value)} type="text" placeholder="Address Line 1" />
                        </div>

                        <div className="w-1/2 mr-2">
                          <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="AddressLine2">
                            Address Line 2
                          </label>
                          <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={addressline2s} onChange={(e) => setAddressLine2s(e.target.value)} type="text" placeholder="Address Line 2" />
                        </div>

                      </div>
                      <div className="w-full mb-4 flex">
                        <div className="w-1/2 mr-2">
                          <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="PinCode">
                            PIN Code
                          </label>

                          <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={pincodes}
                            name="pincode"
                            onChange={(e) => setPostcodes(e.target.value)}
                            type="text"
                            placeholder="Enter Pin Code"
                            list="pinCodesList"
                            onBlur={(e) => handlePinCodeChange(e.target.value)}
                          />
                          <datalist id="pinCodesList">

                            {Array.isArray(pinCodess) && pinCodess.map((pinCode) => (
                              <option key={pinCode.id} value={pinCode.pincode} />
                            ))}
                          </datalist>
                        </div>

                        <div className="w-1/2 mr-2">
                          <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="LandMark">
                            LandMark
                          </label>
                          <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={landMarks} onChange={(e) => setLandMarks(e.target.value)} type="text" placeholder="Landmark" />
                        </div>
                        <div className="w-1/2 mr-2">
                          <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="Town">
                            Town
                          </label>
                          <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={towns} onChange={(e) => setTowns(e.target.value)} type="text" placeholder="Town" />
                        </div>

                        <div className="w-1/2 mr-2">
                          <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="District">
                            District
                          </label>
                          <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={districts} onChange={(e) => setDistricts(e.target.value)} type="text" placeholder="District" />
                        </div>

                        <div className="w-1/2 mr-2">
                          <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="State">
                            State
                          </label>
                          <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={states} onChange={(e) => setStates(e.target.value)} type="text" placeholder="State" />
                        </div>
                        <div className="w-1/2 mr-2">
                          <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="Country">
                            Country
                          </label>
                          <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={countrys} onChange={(e) => setCountrys(e.target.value)} type="text" placeholder="Country" readOnly />
                        </div>
                      </div>
                      <div className="w-full mb-4 flex">
                        <Button
                          variant="contained"
                          style={{ marginLeft: '8px', backgroundColor: '#006400', color: 'white' }}
                          onClick={submitCustomData}
                        >
                          Add Customer
                        </Button>

                        <Button
                          variant="contained"
                          color="error"
                          component={Link}
                          onClick={closeModal}
                          className="linkcolor"
                          style={{ marginLeft: '8px' }}
                        >
                          Cancel
                        </Button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </Modal>
          </div >
        </Fragment >

      )
      }

    </>

  );
}

export default Home;